/* eslint-disable max-len */
import {
    Button,
    Text,
    VStack,
    HStack,
    Spacer,
    MenuItem,
} from '@chakra-ui/react';
import { ConfirmationDialog } from '@acp/core-ui';
import { ReportedFindingDataMachine } from '@acp/shared';
import { ReportedFindingsMachineContext } from '../machine/context';
import { RequestQuoteWizardTable } from './table/request-quote-wizard-table';

function RequestQuoteButton({
    reportedFinding,
}: {
    reportedFinding: ReportedFindingDataMachine;
}) {
    const machine = ReportedFindingsMachineContext.useActorRef();
    return (
        <MenuItem
            onClick={() => machine.send({
                type: 'REQUEST_QUOTE',
                reportedFindingId: reportedFinding.problemRegister.problemRegisterId,
            })}
        >
            Request quote
        </MenuItem>
    );
}

function RequestQuoteWizardDescription() {
    return (
        <VStack w="100%" alignItems="stretch" gap={6}>
            <Text fontSize="md" fontWeight="medium">
                Request a quote from DI
            </Text>
            <Text fontSize="md">
                Please select all findings you would like us to quote for:
            </Text>
        </VStack>
    );
}

function RequestQuoteWizard() {
    const machine = ReportedFindingsMachineContext.useActorRef();
    const selectedRequestQuoteItems = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.selectedItems
    );
    const isLoadingConfirmation = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches('requestQuote')
    );
    const isConfirming = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches('confirmRequestQuote')
    );

    return (
        <>
            <VStack align="left" w="100%" gap={0} mb={4}>
                <RequestQuoteWizardDescription />
                <RequestQuoteWizardTable />
                <HStack justifyContent="end" pt={6}>
                    <Button
                        onClick={() => machine.send({ type: 'BACK' })}
                        size="md"
                        colorScheme="muted"
                        variant="ghost"
                    >
                        Back
                    </Button>
                    <Spacer />
                    <Button
                        colorScheme="secondary"
                        size="md"
                        variant="solid"
                        onClick={() => machine.send({ type: 'NEXT' })}
                        disabled={selectedRequestQuoteItems.length === 0}
                    >
                        <Text>Request quote</Text>
                    </Button>
                </HStack>
            </VStack>
            {isConfirming && (
                <ConfirmationDialog
                    isOpen={isConfirming}
                    title="Are you sure?"
                    confirmText="Request"
                    cancelText="Cancel"
                    onCancel={() => machine.send({ type: 'BACK' })}
                    onConfirm={() => machine.send({ type: 'SUBMIT_QUOTE_REQUEST' })}
                    isLoading={isLoadingConfirmation}
                    isCentered
                    trapFocus={false}
                >
                    The findings selected will be added to the requested quote. Are you sure
                    you want to continue?
                </ConfirmationDialog>
            )}
        </>
    );
}

export { RequestQuoteWizard, RequestQuoteButton };
